import type { IMenu, IMenuSection } from '@/types/menu';
import {
  Building2,
  ChartColumn,
  DollarSign,
  Percent,
  ToggleRight,
} from 'lucide-react';

/**
 * Navigation for the Superadmin Console. Kept fully separate from the CMS
 * `menuSections` so console navigation can evolve independently and is not
 * subject to the CMS permission gating.
 */
export const consoleMenuSections: IMenuSection[] = [
  {
    id: 'main',
    menus: [
      {
        id: 1,
        icon: Building2,
        label: 'Clients',
        route: '/console/clients',
      },
      {
        id: 5,
        icon: ToggleRight,
        label: 'Feature Flags',
        route: '/console/feature-flags',
      },
      {
        id: 4,
        icon: ChartColumn,
        label: 'Client KPI',
        route: '/console/client-kpi',
      },
      {
        id: 3,
        icon: Percent,
        label: 'Tax Setting',
        route: '/console/tax-setting',
      },
      {
        id: 2,
        icon: DollarSign,
        label: 'Administration Fee',
        route: '/console/administration-fee',
        children: [
          {
            id: 21,
            label: 'Fee Settings',
            route: '/console/administration-fee/fee-settings',
          },
          {
            id: 22,
            label: 'Clients & Models',
            route: '/console/administration-fee/clients-models',
          },
          {
            id: 23,
            label: 'Reporting',
            route: '/console/administration-fee/reporting',
          },
          {
            id: 24,
            label: 'Invoices',
            route: '/console/administration-fee/invoices',
          },
        ],
      },
    ],
  },
];

export const consoleMenus: IMenu[] = consoleMenuSections.flatMap(
  section => section.menus
);
